// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__LRNUQ"};